import type { TableColumn } from "@components";
import type { ExpensesPaginatedResponseItem } from "../types";

export const EXPENSES_HISTORY_COLUMNS: TableColumn<ExpensesPaginatedResponseItem>[] =
	[
		{
			id: "date",
			label: "Data",
			minWidth: 110,
		},
		{
			id: "plate",
			label: "Placa",
			minWidth: 110,
		},
		{
			id: "vehicle",
			label: "Veículo",
			minWidth: 160,
		},
		{
			id: "type",
			label: "Tipo",
			minWidth: 130,
		},
		{
			id: "description",
			label: "Descrição",
		},
		{
			id: "amount",
			label: "Valor",
		},
		{
			id: "actions",
			label: "Ações",
			minWidth: 120,
		},
	];
